import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { modularScale } from '../utils';
import theme from '../theme';

const Copy = ({ componentType = 'p', big = false, children, ...restProps }) => {
	const ComponentType = componentType;
	return <ComponentType {...restProps}>{children}</ComponentType>
};

Copy.propTypes = {
	className: PropTypes.string,
	componentType: PropTypes.string,
	big: PropTypes.bool,
	children: PropTypes.node
};

const StyledCopy = styled(Copy)`
	font-weight: normal;
	
	@media (min-width: ${theme.breakpoints.desktop}px) {
		font-size: ${props => props.big ? modularScale(1.5) : undefined};
		font-weight: ${props => props.big ? 300 : "normal"}; 
	}
`;

export default StyledCopy;
